import React from 'react';
import { Box, List, ListItemButton, ListItemText, Typography, Button } from '@mui/material';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

// Persistent admin layout with left sidebar tab menu
const navItems = [
  { label: 'Overview', path: '/admin' },
  { label: 'Orders', path: '/admin/orders' },
  { label: 'Products', path: '/admin/products' },
  { label: 'Categories', path: '/admin/categories' },
  { label: 'Coupons', path: '/admin/coupons' },
  { label: 'Shipping', path: '/admin/shipping' },
  { label: 'Messages', path: '/admin/messages' },
  { label: 'Settings', path: '/admin/settings' }
];

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (itemPath) => {
    if (itemPath === '/admin') return location.pathname === '/admin';
    return location.pathname.startsWith(itemPath);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 64px)', flexDirection: { xs: 'column', sm: 'row' } }}>
      {/* Vertical sidebar for desktop */}
      <Box sx={{
        width: 220,
        borderRight: '1px solid',
        borderColor: 'divider',
        bgcolor: (t) => t.palette.background.paper,
        display: { xs: 'none', sm: 'block' },
        position: 'sticky',
        top: 64,
        height: 'calc(100vh - 64px)',
        overflowY: 'auto',
        flexShrink: 0
      }}>
        <Box sx={{ p: 2.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Admin</Typography>
          <List dense disablePadding>
            {navItems.map(item => (
              <ListItemButton key={item.path} selected={isActive(item.path)} onClick={() => navigate(item.path)} sx={{ mb: .5, borderRadius: 1.5, '&.Mui-selected': { bgcolor: (t)=>t.palette.primary.main + '15', '&:hover': { bgcolor: (t)=>t.palette.primary.main + '25' } } }}>
                <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }} primary={item.label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Box>
      {/* Horizontal bar for mobile */}
      <Box sx={{
        display: { xs: 'flex', sm: 'none' },
        width: '100%',
        overflowX: 'auto',
        bgcolor: (t) => t.palette.background.paper,
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 1,
        py: 1,
        gap: 1,
        position: 'sticky',
        top: 64,
        zIndex: 10
      }}>
        {navItems.map(item => (
          <Button
            key={item.path}
            onClick={() => navigate(item.path)}
            variant={isActive(item.path) ? 'contained' : 'text'}
            color={isActive(item.path) ? 'primary' : 'inherit'}
            size="small"
            sx={{ minWidth: 90, fontWeight: 600, borderRadius: 2, whiteSpace: 'nowrap' }}
          >
            {item.label}
          </Button>
        ))}
      </Box>
      <Box sx={{ flexGrow: 1, px: { xs: 1, md: 4 }, py: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;
